module.exports = __webpack_public_path__ + "img/ikigai_description.be3e5d22.jpeg";